import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class SessionService {

    public data: { [key: string]: any } = {};

    public timeToLive: { [key: string]: any } = {};

    constructor(private router: Router) {
        console.log('Session service constructed');

        router.events.subscribe((val) => {
            // if (val instanceof NavigationEnd) {
            //     Object.keys(this.timeToLive).forEach((item) => {
            //         this.timeToLive[ item ] = this.timeToLive[ item ] - 1;
            //
            //         if (this.timeToLive[ item ] < 0) {
            //             this.forget(item);
            //         }
            //     });
            // }
        });
    }

    public get(name: string) {
        return this.data[name];
    }

    public has(name: string) {
        return !!this.data[name];
    }

    public flash(name: string, value: any) {
        this.data[name]       = value;
        this.timeToLive[name] = 1;
    }

    public forget(name: string) {
        delete this.data[name];
        delete this.timeToLive[name];
    }

    public flush() {
        this.data = {};
    }

}





// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/sessions/session.service.ts